const basicEmailRegex = /.+@.+\..+/;

export const isValidEmail = (email: string) => {
  return basicEmailRegex.test(email);
};
